import { getSizeToken, getVariantToken } from '@koaly/mixins';
import styled, { css } from 'styled-components';

const NavigationLink = styled.a `
  ${({ appearance, variant, size }) => appearance === 'underlined' &&
    css `
      font-weight: bold;
      padding: ${getSizeToken('navigation', 'borderSpacing', size, appearance)} 0px;
      border-bottom: ${getSizeToken('navigation', 'borderSize', size, appearance)} solid transparent;
      &.active, &:hover {
        border-bottom: ${getSizeToken('navigation', 'borderSize', size, appearance)}
         solid ${getVariantToken('navigation', 'borderColorActive', variant, appearance)};
      }
    `};
  /* Reset */
  text-decoration: none;
  display: inline-block;

  /* Styling */
  color: ${({ variant, appearance }) => getVariantToken('navigation', 'linkColor', variant, appearance)};

  &:hover {
    color: ${({ variant, appearance }) => getVariantToken('navigation', 'linkColorHover', variant, appearance)}
  }

  &.active {
    font-weight: bold;
    color: ${({ variant, appearance }) => getVariantToken('navigation', 'linkColorActive', variant, appearance)};
  }
`;
NavigationLink.defaultProps = {
    size: 'medium',
};

export { NavigationLink };
//# sourceMappingURL=NavigationLink.js.map
